import axios from 'axios';

const API_URL = process.env.API_URL;

export async function listMusicForAlbum(q, authorization) {
  const url = `${API_URL}/dashboard/album/ref/music?q=${q}`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListAlbum(filter, authorization, isAdmin) {
  const url = isAdmin ? `${API_URL}/admin/album/list` : `${API_URL}/dashboard/album/list`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailAlbum(idAlbum, authorization, isAdmin) {
  const url = isAdmin ? `${API_URL}/admin/album/detail/${idAlbum}` : `${API_URL}/dashboard/album/detail-album/${idAlbum}`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createAlbum(album, authorization) {
  const url = `${API_URL}/dashboard/album/create-album`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updateAlbum(album, authorization) {
  const url = `${API_URL}/dashboard/album/update-album`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function publishAlbum(album, authorization) {
  const url = `${API_URL}/admin/album/publish`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function unpublishAlbum(album, authorization) {
  const url = `${API_URL}/admin/album/unpublish`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteAlbum(album, authorization, isAdmin) {
  const url = isAdmin ? `${API_URL}/admin/album/delete` : `${API_URL}/dashboard/album/delete`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListAlbumByArtist(filter, authorization, id) {
  const url = `${API_URL}/admin/user-artist/detail/${id}/album`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function countSubmissionContent(status, published = null, authorization, id = null) {
  let url = id !== null ? `${API_URL}/admin/album/count-submission-artist?status=${status}&artist_id=${id}` : `${API_URL}/admin/album/count-submission?status=${status}`;
  if (published) {
    url += '&published=1';
  } else {
    url += '&published=0';
  }
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function approvalAlbum(data, authorization) {
  const url = `${API_URL}/admin/album/approval`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getTagsAlbum(filter, authorization) {
  const url = `${API_URL}/admin/album/search-tag`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function saveTagsAlbum(data, authorization) {
  const url = `${API_URL}/admin/album/add-tag`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createAlbumAdmin(album, authorization) {
  const url = `${API_URL}/admin/album/create`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createAlbumAdminStream(album, authorization) {
  const url = `${API_URL}/admin/album/create`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editAlbumAdmin(album, authorization) {
  const url = `${API_URL}/admin/album/update`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editAlbumAdminStream(album, authorization) {
  const url = `${API_URL}/admin/album/update`;
  return axios({
    url,
    method: 'post',
    data: album,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addSubmitSubmissionProcess(submissionData, authorization) {
  const url = `${API_URL}/admin/album/process-submission`;
  return axios({
    url,
    method: 'post',
    data: submissionData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/album.js